var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":_vm.formattedValue},on:{"input":function($event){return _vm.updateValue($event.target.value)},"keypress":_vm.noAbc,"focus":_vm.onFocus}})}
var staticRenderFns = []

export { render, staticRenderFns }